/** Generation and delivery limits. Plain values with no PDF library dependency, so the submission
 * routes can share them without loading the PDF engine. Actual Cloudflare CPU/memory must be validated
 * before release. Transport/upload routes must bound streams before buffering too. */
export const PDF_LIMITS = Object.freeze({
  documents: 3, sourceBytes: 5 * 1024 * 1024, aggregateSourceBytes: 15 * 1024 * 1024,
  placements: 50, questions: 50, nativeWidgets: 100, indirectObjects: 5000,
  imagePixels: 4_000_000, aggregateImagePixels: 8_000_000, pagePoints: 1440,
  textCharacters: 4096, aggregateTextCharacters: 32768, fontBytes: 12 * 1024 * 1024,
  maximumFontSize: 24, outputBytes: 8 * 1024 * 1024, aggregateOutputBytes: 24 * 1024 * 1024,
});
